/*! GeoRide Chat · widget maison georide.fr · v0.24 (2026-09-04)
 *  Branché sur l'API « GeoRide website chat » (api-v2, /v1/support/web).
 *  Un seul fichier, zéro dépendance. Chargé en defer, ne fait aucun appel réseau
 *  tant que le visiteur n'envoie pas de message (sauf reprise d'une conversation).
 *
 *  Intégration Shopify (theme.liquid, juste avant </body>) :
 *    <script src="{{ 'georide-chat.js' | asset_url }}" defer
 *            data-page="{{ request.page_type }}" data-lang="{{ request.locale.iso_code }}"></script>
 *  ou, si le fichier est hébergé dans Contenu → Fichiers : src="https://cdn.shopify.com/s/files/.../georide-chat.js"
 *
 *  Options (attributs data-* du script ou window.GeoRideChatConfig) :
 *    page   : index|product|page|article|blog|collection|cart… (Shopify request.page_type) ou accueil|produit|achat|contact|blog|autre
 *    lang   : force la langue (tests). Sinon : data-site-lang (locale Shopify de la page, ou <html lang>), puis langues du navigateur, puis anglais hors site FR.
 *    site-lang : locale du site (request.locale.iso_code) : la langue du chat suit la langue de la page.
 *    Langues : fr, en, de, es, it, nl, pt, pl.
 *    scheme : orange|bleu|nuit (défaut orange)
 *    api    : base de l'API (défaut https://api-v2.georide.com)
 *    lift   : "1" pour remonter la bulle de 96 px (barre collante mobile de la page d'achat, auto sur cette page)
 *    avatars-base : dossier des portraits georide-chat-av-XX.jpg (défaut : le dossier du script lui-même)
 *    #chat dans l'URL ouvre le chat au chargement (lien profond, tests). #chat-test rejoue la relance au bout de 1,5 s.
 *    split-greeting : "1" pour afficher le « Bonjour, » de la réponse dans une première bulle, puis le reste 2 à 4 s après
 *  Page contact : si un conteneur <div id="georide-chat"></div> existe, le chat s'y ancre en pleine page, sans bulle.
 */
(function () {
  'use strict';
  if (window.__georideChatLoaded) return;
  window.__georideChatLoaded = true;

  /* ───────── configuration ───────── */
  var SCRIPT = document.currentScript;
  var DS = (SCRIPT && SCRIPT.dataset) || {};
  var CFG = {
    api: 'https://api-v2.georide.com',
    page: '',
    lang: '',
    scheme: 'orange',
    lift: null,
    teaserDelay: 7000,
    teaserScrollPx: 400,
    teaserScrollPxMobile: 350,
    pollInterval: 2000,
    pollTimeout: 60000,
    storageKey: 'georide_chat_conv',
    teaserKey: 'georide_chat_teaser_at',
    pendingKey: 'georide_chat_pending',
    kbKey: 'georide_chat_kb',
    teaserCooldownMin: 30,
    splitGreeting: false,
    siteLang: '',
    avatarsBase: '',
    zIndex: 9990,
    zIndexPanel: 2147483000
  };
  var over = window.GeoRideChatConfig || {};
  Object.keys(over).forEach(function (k) { CFG[k] = over[k]; });
  ['api', 'page', 'lang', 'siteLang', 'scheme', 'lift', 'avatarsBase'].forEach(function (k) { if (DS[k] != null && DS[k] !== '') CFG[k] = DS[k]; });
  if (DS.splitGreeting === '1' || DS.splitGreeting === 'true') CFG.splitGreeting = true;
  if (CFG.lift === '0' || CFG.lift === 'false') CFG.lift = false;
  if (CFG.lift === '1' || CFG.lift === 'true') CFG.lift = true;

  /* ───────── textes (FR/EN) ───────── */
  /* Textes de l'interface (l'IA répond dans la langue du visiteur, quel que soit l'habillage). */
  var L = {
    "fr": {
      "ui": {
        "name": "L'équipe GeoRide",
        "status": "En ligne · moins de 5 min",
        "placeholder": "Écrivez votre message…",
        "sent": "Envoyé",
        "seen": "Vu",
        "open": "Ouvrir le chat",
        "close": "Fermer",
        "send": "Envoyer",
        "retry": "Réessayer",
        "newConv": "Nouvelle conversation",
        "errTimeout": "Désolé, nous n'avons pas réussi à vous répondre. Vous pouvez réessayer.",
        "errBusy": "Beaucoup de messages en ce moment, réessayez dans quelques minutes.",
        "errDown": "Notre service de réponse est momentanément indisponible, réessayez dans un instant.",
        "errNet": "La connexion a échoué. Vérifiez votre réseau et réessayez.",
        "errFull": "Cette conversation est arrivée à sa limite, on repart sur une nouvelle."
      },
      "welcome": {
        "accueil": "Bonjour 👋 Bienvenue chez GeoRide ! Une question sur le boîtier, les offres ou votre commande ? On vous répond tout de suite.",
        "produit": "Bonjour 👋 Une question sur GeoRide, son fonctionnement ou la compatibilité avec votre moto ? On vous répond tout de suite.",
        "achat": "Bonjour 👋 Un doute avant de choisir votre formule ? Posez votre question, on vous répond immédiatement.",
        "contact": "Bonjour 👋 Vous êtes au bon endroit : posez votre question, on vous répond en direct. Commande, abonnement, installation, SAV, on gère tout ici."
      },
      "teasers": {
        "produit": "Bonjour 👋 Une question sur GeoRide ? On vous répond en quelques secondes.",
        "achat": "Un doute avant de vous lancer ? Posez-nous votre question, réponse immédiate 🙂",
        "accueil": "Bonjour 👋 Besoin d'un conseil ? On est là, réponse en quelques secondes."
      },
      "chips": {
        "accueil": [
          "Compatible avec ma moto ?",
          "3s ou mini, lequel choisir ?",
          "Location ou achat, que choisir ?",
          "Ça marche à l'étranger ?"
        ],
        "produit": [
          "Compatible avec ma moto ?",
          "3s ou mini, lequel choisir ?",
          "Location ou achat, que choisir ?",
          "Ça marche à l'étranger ?"
        ],
        "achat": [
          "Compatible avec ma moto ?",
          "3s ou mini, lequel choisir ?",
          "Location ou achat, que choisir ?",
          "Ça marche à l'étranger ?"
        ],
        "contact": [
          "Suivre ma commande",
          "Un souci avec mon GeoRide",
          "Passer au GeoRide 3s",
          "Compatible avec ma moto ?"
        ]
      }
    },
    "en": {
      "ui": {
        "name": "The GeoRide team",
        "status": "Online · under 5 min",
        "placeholder": "Type your message…",
        "sent": "Sent",
        "seen": "Seen",
        "open": "Open chat",
        "close": "Close",
        "send": "Send",
        "retry": "Try again",
        "newConv": "New conversation",
        "errTimeout": "Sorry, we couldn't answer this time. You can try again.",
        "errBusy": "Lots of messages right now, please try again in a few minutes.",
        "errDown": "Our answering service is temporarily unavailable, please try again shortly.",
        "errNet": "The connection failed. Check your network and try again.",
        "errFull": "This conversation reached its limit, we are starting a new one."
      },
      "welcome": {
        "accueil": "Hi 👋 Welcome to GeoRide! Any question about the tracker, our plans or your order? We're right here.",
        "produit": "Hi 👋 Any question about GeoRide, how it works or whether it fits your bike? We answer right away.",
        "achat": "Hi 👋 Not sure which plan to pick? Ask away, we'll answer right now.",
        "contact": "Hi 👋 You're in the right place: ask your question, we answer live. Orders, subscriptions, installation, support, we handle everything here."
      },
      "teasers": {
        "produit": "Hi 👋 A question about GeoRide? We answer within seconds.",
        "achat": "Second thoughts before you go for it? Ask us anything, instant answer 🙂",
        "accueil": "Hi 👋 Need advice? We're here, answers within seconds."
      },
      "chips": {
        "accueil": [
          "Will it fit my bike?",
          "3s or mini, which one?",
          "Rent or buy?",
          "Does it work abroad?"
        ],
        "produit": [
          "Will it fit my bike?",
          "3s or mini, which one?",
          "Rent or buy?",
          "Does it work abroad?"
        ],
        "achat": [
          "Will it fit my bike?",
          "3s or mini, which one?",
          "Rent or buy?",
          "Does it work abroad?"
        ],
        "contact": [
          "Track my order",
          "An issue with my GeoRide",
          "Upgrade to the GeoRide 3s",
          "Will it fit my bike?"
        ]
      }
    },
    "de": {
      "ui": {
        "name": "Das GeoRide-Team",
        "status": "Online · unter 5 Min.",
        "placeholder": "Schreiben Sie Ihre Nachricht…",
        "sent": "Gesendet",
        "seen": "Gelesen",
        "open": "Chat öffnen",
        "close": "Schließen",
        "send": "Senden",
        "retry": "Erneut versuchen",
        "newConv": "Neue Unterhaltung",
        "errTimeout": "Entschuldigung, wir konnten diesmal nicht antworten. Sie können es erneut versuchen.",
        "errBusy": "Gerade sehr viele Nachrichten, bitte versuchen Sie es in ein paar Minuten noch einmal.",
        "errDown": "Unser Antwortdienst ist vorübergehend nicht erreichbar, bitte versuchen Sie es gleich noch einmal.",
        "errNet": "Die Verbindung ist fehlgeschlagen. Prüfen Sie Ihr Netzwerk und versuchen Sie es erneut.",
        "errFull": "Diese Unterhaltung hat ihr Limit erreicht, wir beginnen eine neue."
      },
      "welcome": {
        "accueil": "Hallo 👋 Willkommen bei GeoRide! Eine Frage zum Tracker, zu unseren Angeboten oder Ihrer Bestellung? Wir antworten sofort.",
        "produit": "Hallo 👋 Eine Frage zu GeoRide, zur Funktionsweise oder ob er zu Ihrem Motorrad passt? Wir antworten sofort.",
        "achat": "Hallo 👋 Unsicher, welches Angebot passt? Stellen Sie Ihre Frage, wir antworten sofort.",
        "contact": "Hallo 👋 Hier sind Sie richtig: Stellen Sie Ihre Frage, wir antworten live. Bestellung, Abo, Einbau, Support, alles läuft hier."
      },
      "teasers": {
        "produit": "Hallo 👋 Eine Frage zu GeoRide? Wir antworten in wenigen Sekunden.",
        "achat": "Noch Zweifel vor dem Kauf? Fragen Sie uns, sofortige Antwort 🙂",
        "accueil": "Hallo 👋 Brauchen Sie Rat? Wir sind da, Antwort in wenigen Sekunden."
      },
      "chips": {
        "accueil": [
          "Passt es zu meinem Motorrad?",
          "3s oder mini, welcher?",
          "Mieten oder kaufen?",
          "Funktioniert es im Ausland?"
        ],
        "produit": [
          "Passt es zu meinem Motorrad?",
          "3s oder mini, welcher?",
          "Mieten oder kaufen?",
          "Funktioniert es im Ausland?"
        ],
        "achat": [
          "Passt es zu meinem Motorrad?",
          "3s oder mini, welcher?",
          "Mieten oder kaufen?",
          "Funktioniert es im Ausland?"
        ],
        "contact": [
          "Meine Bestellung verfolgen",
          "Ein Problem mit meinem GeoRide",
          "Auf den GeoRide 3s wechseln",
          "Passt es zu meinem Motorrad?"
        ]
      }
    },
    "es": {
      "ui": {
        "name": "El equipo GeoRide",
        "status": "En línea · menos de 5 min",
        "placeholder": "Escribe tu mensaje…",
        "sent": "Enviado",
        "seen": "Visto",
        "open": "Abrir el chat",
        "close": "Cerrar",
        "send": "Enviar",
        "retry": "Reintentar",
        "newConv": "Nueva conversación",
        "errTimeout": "Lo sentimos, no hemos podido responder esta vez. Puedes volver a intentarlo.",
        "errBusy": "Hay muchos mensajes ahora mismo, vuelve a intentarlo en unos minutos.",
        "errDown": "Nuestro servicio de respuesta no está disponible por el momento, vuelve a intentarlo en un instante.",
        "errNet": "La conexión ha fallado. Comprueba tu red y vuelve a intentarlo.",
        "errFull": "Esta conversación ha llegado a su límite, empezamos una nueva."
      },
      "welcome": {
        "accueil": "Hola 👋 ¡Bienvenido a GeoRide! ¿Alguna duda sobre el localizador, las ofertas o tu pedido? Te respondemos ahora mismo.",
        "produit": "Hola 👋 ¿Alguna duda sobre GeoRide, cómo funciona o si es compatible con tu moto? Te respondemos ahora mismo.",
        "achat": "Hola 👋 ¿Dudas antes de elegir tu fórmula? Pregunta, te respondemos al momento.",
        "contact": "Hola 👋 Estás en el lugar adecuado: haz tu pregunta y te respondemos en directo. Pedido, suscripción, instalación, soporte, lo gestionamos todo aquí."
      },
      "teasers": {
        "produit": "Hola 👋 ¿Alguna duda sobre GeoRide? Te respondemos en segundos.",
        "achat": "¿Dudas antes de lanzarte? Pregúntanos, respuesta inmediata 🙂",
        "accueil": "Hola 👋 ¿Necesitas un consejo? Estamos aquí, respuesta en segundos."
      },
      "chips": {
        "accueil": [
          "¿Es compatible con mi moto?",
          "¿3s o mini, cuál elegir?",
          "¿Alquiler o compra?",
          "¿Funciona en el extranjero?"
        ],
        "produit": [
          "¿Es compatible con mi moto?",
          "¿3s o mini, cuál elegir?",
          "¿Alquiler o compra?",
          "¿Funciona en el extranjero?"
        ],
        "achat": [
          "¿Es compatible con mi moto?",
          "¿3s o mini, cuál elegir?",
          "¿Alquiler o compra?",
          "¿Funciona en el extranjero?"
        ],
        "contact": [
          "Seguir mi pedido",
          "Un problema con mi GeoRide",
          "Pasar al GeoRide 3s",
          "¿Es compatible con mi moto?"
        ]
      }
    },
    "it": {
      "ui": {
        "name": "Il team GeoRide",
        "status": "Online · meno di 5 min",
        "placeholder": "Scrivi il tuo messaggio…",
        "sent": "Inviato",
        "seen": "Visto",
        "open": "Apri la chat",
        "close": "Chiudi",
        "send": "Invia",
        "retry": "Riprova",
        "newConv": "Nuova conversazione",
        "errTimeout": "Ci dispiace, non siamo riusciti a rispondere. Puoi riprovare.",
        "errBusy": "Ci sono molti messaggi in questo momento, riprova tra qualche minuto.",
        "errDown": "Il nostro servizio di risposta è momentaneamente non disponibile, riprova tra poco.",
        "errNet": "Connessione non riuscita. Controlla la rete e riprova.",
        "errFull": "Questa conversazione ha raggiunto il limite, ne iniziamo una nuova."
      },
      "welcome": {
        "accueil": "Ciao 👋 Benvenuto da GeoRide! Una domanda sul localizzatore, sulle offerte o sul tuo ordine? Ti rispondiamo subito.",
        "produit": "Ciao 👋 Una domanda su GeoRide, su come funziona o sulla compatibilità con la tua moto? Ti rispondiamo subito.",
        "achat": "Ciao 👋 Un dubbio prima di scegliere la formula? Fai la tua domanda, ti rispondiamo immediatamente.",
        "contact": "Ciao 👋 Sei nel posto giusto: fai la tua domanda, ti rispondiamo in diretta. Ordine, abbonamento, installazione, assistenza, gestiamo tutto qui."
      },
      "teasers": {
        "produit": "Ciao 👋 Una domanda su GeoRide? Ti rispondiamo in pochi secondi.",
        "achat": "Un dubbio prima di decidere? Chiedici pure, risposta immediata 🙂",
        "accueil": "Ciao 👋 Serve un consiglio? Siamo qui, risposta in pochi secondi."
      },
      "chips": {
        "accueil": [
          "È compatibile con la mia moto?",
          "3s o mini, quale scegliere?",
          "Noleggio o acquisto?",
          "Funziona all'estero?"
        ],
        "produit": [
          "È compatibile con la mia moto?",
          "3s o mini, quale scegliere?",
          "Noleggio o acquisto?",
          "Funziona all'estero?"
        ],
        "achat": [
          "È compatibile con la mia moto?",
          "3s o mini, quale scegliere?",
          "Noleggio o acquisto?",
          "Funziona all'estero?"
        ],
        "contact": [
          "Seguire il mio ordine",
          "Un problema con il mio GeoRide",
          "Passare al GeoRide 3s",
          "È compatibile con la mia moto?"
        ]
      }
    },
    "nl": {
      "ui": {
        "name": "Het GeoRide-team",
        "status": "Online · binnen 5 min",
        "placeholder": "Typ je bericht…",
        "sent": "Verzonden",
        "seen": "Gelezen",
        "open": "Chat openen",
        "close": "Sluiten",
        "send": "Verzenden",
        "retry": "Opnieuw proberen",
        "newConv": "Nieuw gesprek",
        "errTimeout": "Sorry, het is ons deze keer niet gelukt te antwoorden. Je kunt het opnieuw proberen.",
        "errBusy": "Er komen nu veel berichten binnen, probeer het over een paar minuten opnieuw.",
        "errDown": "Onze antwoordservice is tijdelijk niet beschikbaar, probeer het zo opnieuw.",
        "errNet": "De verbinding is mislukt. Controleer je netwerk en probeer het opnieuw.",
        "errFull": "Dit gesprek heeft zijn limiet bereikt, we beginnen een nieuw gesprek."
      },
      "welcome": {
        "accueil": "Hallo 👋 Welkom bij GeoRide! Een vraag over de tracker, onze formules of je bestelling? We antwoorden meteen.",
        "produit": "Hallo 👋 Een vraag over GeoRide, hoe het werkt of of het op je motor past? We antwoorden meteen.",
        "achat": "Hallo 👋 Twijfel je nog welke formule je kiest? Stel je vraag, we antwoorden direct.",
        "contact": "Hallo 👋 Je bent op de juiste plek: stel je vraag, we antwoorden live. Bestelling, abonnement, installatie, service, alles regelen we hier."
      },
      "teasers": {
        "produit": "Hallo 👋 Een vraag over GeoRide? We antwoorden binnen enkele seconden.",
        "achat": "Nog twijfels voor je bestelt? Stel je vraag, direct antwoord 🙂",
        "accueil": "Hallo 👋 Advies nodig? We zijn er, antwoord binnen enkele seconden."
      },
      "chips": {
        "accueil": [
          "Past het op mijn motor?",
          "3s of mini, welke kiezen?",
          "Huren of kopen?",
          "Werkt het in het buitenland?"
        ],
        "produit": [
          "Past het op mijn motor?",
          "3s of mini, welke kiezen?",
          "Huren of kopen?",
          "Werkt het in het buitenland?"
        ],
        "achat": [
          "Past het op mijn motor?",
          "3s of mini, welke kiezen?",
          "Huren of kopen?",
          "Werkt het in het buitenland?"
        ],
        "contact": [
          "Mijn bestelling volgen",
          "Een probleem met mijn GeoRide",
          "Overstappen naar de GeoRide 3s",
          "Past het op mijn motor?"
        ]
      }
    },
    "pt": {
      "ui": {
        "name": "A equipa GeoRide",
        "status": "Online · menos de 5 min",
        "placeholder": "Escreva a sua mensagem…",
        "sent": "Enviado",
        "seen": "Visto",
        "open": "Abrir o chat",
        "close": "Fechar",
        "send": "Enviar",
        "retry": "Tentar novamente",
        "newConv": "Nova conversa",
        "errTimeout": "Desculpe, não conseguimos responder desta vez. Pode tentar novamente.",
        "errBusy": "Há muitas mensagens neste momento, tente novamente dentro de alguns minutos.",
        "errDown": "O nosso serviço de resposta está temporariamente indisponível, tente novamente daqui a pouco.",
        "errNet": "A ligação falhou. Verifique a sua rede e tente novamente.",
        "errFull": "Esta conversa chegou ao limite, vamos começar uma nova."
      },
      "welcome": {
        "accueil": "Olá 👋 Bem-vindo à GeoRide! Alguma dúvida sobre o localizador, as ofertas ou a sua encomenda? Respondemos já.",
        "produit": "Olá 👋 Alguma dúvida sobre o GeoRide, como funciona ou se é compatível com a sua mota? Respondemos já.",
        "achat": "Olá 👋 Dúvidas antes de escolher a sua fórmula? Faça a sua pergunta, respondemos de imediato.",
        "contact": "Olá 👋 Está no sítio certo: faça a sua pergunta, respondemos em direto. Encomenda, subscrição, instalação, assistência, tratamos de tudo aqui."
      },
      "teasers": {
        "produit": "Olá 👋 Alguma dúvida sobre o GeoRide? Respondemos em segundos.",
        "achat": "Dúvidas antes de avançar? Pergunte-nos, resposta imediata 🙂",
        "accueil": "Olá 👋 Precisa de um conselho? Estamos aqui, resposta em segundos."
      },
      "chips": {
        "accueil": [
          "É compatível com a minha mota?",
          "3s ou mini, qual escolher?",
          "Aluguer ou compra?",
          "Funciona no estrangeiro?"
        ],
        "produit": [
          "É compatível com a minha mota?",
          "3s ou mini, qual escolher?",
          "Aluguer ou compra?",
          "Funciona no estrangeiro?"
        ],
        "achat": [
          "É compatível com a minha mota?",
          "3s ou mini, qual escolher?",
          "Aluguer ou compra?",
          "Funciona no estrangeiro?"
        ],
        "contact": [
          "Seguir a minha encomenda",
          "Um problema com o meu GeoRide",
          "Passar para o GeoRide 3s",
          "É compatível com a minha mota?"
        ]
      }
    },
    "pl": {
      "ui": {
        "name": "Zespół GeoRide",
        "status": "Online · poniżej 5 min",
        "placeholder": "Napisz wiadomość…",
        "sent": "Wysłano",
        "seen": "Odczytano",
        "open": "Otwórz czat",
        "close": "Zamknij",
        "send": "Wyślij",
        "retry": "Spróbuj ponownie",
        "newConv": "Nowa rozmowa",
        "errTimeout": "Przepraszamy, tym razem nie udało nam się odpowiedzieć. Możesz spróbować ponownie.",
        "errBusy": "Mamy teraz bardzo dużo wiadomości, spróbuj ponownie za kilka minut.",
        "errDown": "Nasza usługa odpowiedzi jest chwilowo niedostępna, spróbuj ponownie za moment.",
        "errNet": "Połączenie nie powiodło się. Sprawdź sieć i spróbuj ponownie.",
        "errFull": "Ta rozmowa osiągnęła limit, zaczynamy nową."
      },
      "welcome": {
        "accueil": "Cześć 👋 Witamy w GeoRide! Pytanie o lokalizator, oferty lub zamówienie? Odpowiadamy od razu.",
        "produit": "Cześć 👋 Pytanie o GeoRide, jak działa albo czy pasuje do Twojego motocykla? Odpowiadamy od razu.",
        "achat": "Cześć 👋 Wahasz się, którą opcję wybrać? Zadaj pytanie, odpowiadamy natychmiast.",
        "contact": "Cześć 👋 Jesteś we właściwym miejscu: zadaj pytanie, odpowiadamy na żywo. Zamówienie, abonament, montaż, serwis, wszystko załatwiamy tutaj."
      },
      "teasers": {
        "produit": "Cześć 👋 Pytanie o GeoRide? Odpowiadamy w kilka sekund.",
        "achat": "Masz wątpliwości przed zakupem? Zapytaj nas, natychmiastowa odpowiedź 🙂",
        "accueil": "Cześć 👋 Potrzebujesz porady? Jesteśmy tu, odpowiedź w kilka sekund."
      },
      "chips": {
        "accueil": [
          "Czy pasuje do mojego motocykla?",
          "3s czy mini, który wybrać?",
          "Wynajem czy zakup?",
          "Czy działa za granicą?"
        ],
        "produit": [
          "Czy pasuje do mojego motocykla?",
          "3s czy mini, który wybrać?",
          "Wynajem czy zakup?",
          "Czy działa za granicą?"
        ],
        "achat": [
          "Czy pasuje do mojego motocykla?",
          "3s czy mini, który wybrać?",
          "Wynajem czy zakup?",
          "Czy działa za granicą?"
        ],
        "contact": [
          "Śledzić moje zamówienie",
          "Problem z moim GeoRide",
          "Przejść na GeoRide 3s",
          "Czy pasuje do mojego motocykla?"
        ]
      }
    }
  };

  /* Réserve de portraits (fichiers georide-chat-av-XX.jpg à côté du script). L'équipe affichée change
     chaque jour, avec une équipe de jour (7h-21h) et une équipe de nuit, choisies de façon stable pour tous
     les visiteurs d'une même journée. Sans fichiers distants, repli sur les 3 portraits intégrés. */
  /* [numéro, famille] : jamais deux membres d'une même famille (ressemblance) dans une équipe, et toujours au moins une femme (familles w*). */
  var AVATAR_POOL = [['01', 'w1'], ['02', 'm2'], ['03', 'm3'], ['04', 'w4'], ['05', 'h'], ['06', 'w6'], ['07', 'm7'], ['08', 'w8'], ['09', 'm9'], ['10', 'h'], ['11', 'w1'], ['12', 'm12']];
  var AVATARS_EMBEDDED = ["data:image/jpeg;base64,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", "data:image/jpeg;base64,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", "data:image/jpeg;base64,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"];

  function seededRandom(seed) {
    var x = (seed ^ 0x9e3779b9) >>> 0;
    return function () {
      x = (Math.imul(x ^ (x >>> 15), 2246822519) ^ (x >>> 13)) >>> 0;
      x = (Math.imul(x, 3266489917) + 374761393) >>> 0;
      return (x >>> 8) / 16777216;
    };
  }
  function pickTeam(pool, seed, n) {
    var rnd = seededRandom(seed), arr = pool.slice(), team = [], fams = {};
    var draw = function (filter) {
      var cands = arr.filter(function (e) { return !fams[e[1]] && (!filter || filter(e)); });
      if (!cands.length) return null;
      var e = cands[Math.floor(rnd() * cands.length)];
      arr.splice(arr.indexOf(e), 1); fams[e[1]] = 1; team.push(e); return e;
    };
    draw(function (e) { return e[1].charAt(0) === 'w'; });
    while (team.length < n && draw()) {}
    return team;
  }
  function avatarBase() {
    if (CFG.avatarsBase) return CFG.avatarsBase;
    var src = SCRIPT && SCRIPT.src;
    if (!src || !/georide-chat\.js/.test(src)) return null;
    return src.replace(/georide-chat\.js.*$/, '');
  }
  function pickAvatars() {
    var base = avatarBase();
    if (!base) return AVATARS_EMBEDDED;
    var now = new Date(), h = now.getHours();
    var day = Math.floor((now.getTime() - now.getTimezoneOffset() * 60000) / 86400000);
    var team = pickTeam(AVATAR_POOL, day, 3);
    if (h >= 21 || h < 7) {
      var used = team.map(function (e) { return e[0]; });
      team = pickTeam(AVATAR_POOL.filter(function (e) { return used.indexOf(e[0]) < 0; }), day + 5000, 3);
    }
    /* ordre d'affichage mélangé aussi, pour ne pas toujours avoir la femme en premier */
    var rnd = seededRandom(day + 99);
    team.sort(function () { return rnd() - 0.5; });
    return team.map(function (e) { return base + 'georide-chat-av-' + e[0] + '.jpg'; });
  }
  var AVATARS = AVATARS_EMBEDDED;

  /* ───────── état ───────── */
  var S = { page: '', lang: 'fr', pair: null, known: {}, open: false, started: false, historyLoaded: false, inline: false, teaserShown: false, destroyed: false };

  /* Langue de l'interface = langue de la page (locale Shopify passée en data-site-lang : fr sur georide.fr,
     en sur eu.georide.com, it sur /it). Le navigateur ne sert que si la page ne donne rien de connu. */
  function detectLang() {
    var force = String(CFG.lang || '').slice(0, 2).toLowerCase();
    if (force && L[force]) return force;
    var site = String(CFG.siteLang || document.documentElement.lang || '').slice(0, 2).toLowerCase();
    if (L[site]) return site;
    var nav = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language];
    for (var i = 0; i < nav.length; i++) {
      var l = String(nav[i] || '').slice(0, 2).toLowerCase();
      if (L[l]) return l;
    }
    return site && site !== 'fr' ? 'en' : 'fr';
  }
  function detectPage() {
    var v = String(CFG.page || '').toLowerCase();
    var path = location.pathname.replace(/\/+$/, '');
    var byPath = function () {
      if (path === '') return 'accueil';
      if (/^\/products\/abonnement/.test(path)) return 'achat';
      if (/^\/products\//.test(path)) return 'produit';
      if (/^\/acheter$|^\/pages\/(acheter|offres|louer|louer-mon-georide)$/.test(path)) return 'achat';
      if (/^\/pages\/contact/.test(path)) return 'contact';
      if (/^\/blogs\//.test(path)) return 'blog';
      return 'autre';
    };
    if (!v) return byPath();
    var map = { index: 'accueil', home: 'accueil', product: 'produit', article: 'blog', blog: 'blog', collection: 'autre', cart: 'autre', search: 'autre', list_collections: 'autre', '404': 'autre' };
    if (v === 'product' || v === 'page') return byPath();
    if (map[v]) return map[v];
    return ({ accueil: 1, produit: 1, achat: 1, contact: 1, blog: 1, autre: 1 })[v] ? v : 'autre';
  }
  function T() { return L[S.lang]; }
  function txt(group) { var g = T()[group]; return g[S.page] || g.accueil; }

  /* ───────── stockage local ───────── */
  function loadPair() { try { var v = JSON.parse(localStorage.getItem(CFG.storageKey) || 'null'); return v && v.id && v.token ? v : null; } catch (e) { return null; } }
  function savePair(p) { try { localStorage.setItem(CFG.storageKey, JSON.stringify(p)); } catch (e) {} }
  function dropPair() { S.pair = null; try { localStorage.removeItem(CFG.storageKey); } catch (e) {} }

  /* ───────── API ───────── */
  function api(method, path, body, token) {
    var h = { Accept: 'application/json' };
    if (body) h['Content-Type'] = 'application/json';
    if (token) h['X-Conversation-Token'] = token;
    return fetch(CFG.api + path, { method: method, headers: h, body: body ? JSON.stringify(body) : undefined, credentials: 'omit' })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = null; try { j = t ? JSON.parse(t) : null; } catch (e) {}
          return { status: r.status, ok: r.ok, body: j, headers: r.headers };
        });
      }, function () { throw { kind: 'network' }; });
  }
  function fail(r) { return { kind: 'http', status: r.status, code: (r.body && r.body.code) || '' }; }

  function ensureConversation() {
    if (S.pair) return Promise.resolve(S.pair);
    return api('POST', '/v1/support/web/conversations').then(function (r) {
      if (r.status === 201 && r.body && r.body.id && r.body.token) {
        S.pair = { id: r.body.id, token: r.body.token, createdAt: r.body.createdAt };
        S.known = {};
        savePair(S.pair);
        return S.pair;
      }
      throw fail(r);
    });
  }
  function postMessage(text, retried) {
    return ensureConversation().then(function (pair) {
      return api('POST', '/v1/support/web/conversations/' + encodeURIComponent(pair.id) + '/messages', { text: text }, pair.token);
    }).then(function (r) {
      if (r.status === 202) return r.body;
      var e = fail(r);
      /* conversation pleine, fermée sans reprise possible, ou inconnue : on repart sur une neuve, une seule fois */
      if (!retried && (r.status === 409 || (r.status === 404 && e.code === 'SUPPORT_WEB_CONVERSATION_NOT_FOUND'))) {
        dropPair();
        return postMessage(text, true);
      }
      throw e;
    });
  }
  function listMessages(pair) {
    return api('GET', '/v1/support/web/conversations/' + encodeURIComponent(pair.id) + '/messages?limit=50', null, pair.token).then(function (r) {
      if (r.status !== 200) throw fail(r);
      var data = (r.body && r.body.data) || [];
      return data.slice().sort(function (a, b) { return a.createdAt < b.createdAt ? -1 : a.createdAt > b.createdAt ? 1 : 0; });
    });
  }
  /* Envois concurrents : le visiteur peut écrire pendant que l'équipe « répond ». Une seule boucle de sondage
     (toutes les 2 s) tant qu'il reste des messages sans réponse ; chaque réponse est affichée une fois, dans
     l'ordre. Les horodatages du moteur datent le message visiteur et sa réponse à la fin du tour, ce qui permet
     de savoir quels envois ont été traités. Abandon après 60 s sans nouvelle réponse. */
  var pending = {}, polling = false, lastActivity = 0, revealNotBefore = 0, lastText = '';
  function pendingCount() { return Object.keys(pending).length; }
  /* Les envois en attente survivent à un changement de page : conversation, messages sans réponse, identifiants
     déjà vus. La page suivante reprend le sondage en arrière-plan et prévient le visiteur quand la réponse arrive. */
  function savePending() {
    try {
      if (!S.pair || !pendingCount()) { localStorage.removeItem(CFG.pendingKey); return; }
      localStorage.setItem(CFG.pendingKey, JSON.stringify({ conv: S.pair.id, pending: pending, lastActivity: lastActivity, lastText: lastText, known: Object.keys(S.known) }));
    } catch (e) {}
  }
  function resumePending() {
    var v = null;
    try { v = JSON.parse(localStorage.getItem(CFG.pendingKey) || 'null'); } catch (e) {}
    if (!v || !S.pair || v.conv !== S.pair.id || !v.pending || !Object.keys(v.pending).length) return;
    pending = v.pending; lastActivity = v.lastActivity || Date.now(); lastText = v.lastText || '';
    (v.known || []).forEach(function (id) { S.known[id] = 1; });
    if (Date.now() - lastActivity > CFG.pollTimeout) { pending = {}; savePending(); return; }
    startPolling();
  }
  function startPolling() { if (polling) return; polling = true; pollTick(); }
  function pollTick() {
    setTimeout(function () {
      if (!S.pair || !pendingCount()) { polling = false; return; }
      listMessages(S.pair).then(function (msgs) {
        var fresh = [], lastAssistantAt = '';
        msgs.forEach(function (m) {
          if (m.role === 'assistant') {
            if (m.createdAt > lastAssistantAt) lastAssistantAt = m.createdAt;
            if (!S.known[m.id]) fresh.push(m);
          }
        });
        msgs.forEach(function (m) {
          if (m.role === 'user' && pending[m.id] && lastAssistantAt && m.createdAt <= lastAssistantAt) delete pending[m.id];
          S.known[m.id] = 1;
        });
        if (fresh.length) { lastActivity = Date.now(); revealReplies(fresh); }
        savePending();
        if (pendingCount() && Date.now() - lastActivity > CFG.pollTimeout) return failPending({ kind: 'timeout' });
        if (pendingCount()) pollTick(); else polling = false;
      }, function (e) {
        if (e && e.status === 404) { dropPair(); return failPending(e); }
        if (e && e.code === 'SUPPORT_WEB_CHAT_DISABLED') return destroy();
        pollTick();
      });
    }, CFG.pollInterval);
  }
  function failPending(e) {
    pending = {}; polling = false; savePending();
    if (!S.historyLoaded) return;
    showTyping(false);
    msgsEl.querySelectorAll('.grc-status').forEach(function (el) { el.remove(); });
    var U = T().ui;
    if (e && e.kind === 'timeout') return addError(U.errTimeout, lastText);
    addError(U.errDown, lastText);
  }
  /* Les réponses arrivées trop tôt attendent la fin de la chorégraphie ; plusieurs réponses s'enchaînent. */
  var revealChain = Promise.resolve();
  function revealReplies(list) {
    list.sort(function (x, y) { return x.createdAt < y.createdAt ? -1 : 1; });
    list.forEach(function (m) {
      revealChain = revealChain.then(function () {
        return new Promise(function (done) {
          if (!S.historyLoaded) { notifyReply(m); return done(); }
          var wait = Math.max(0, revealNotBefore - Date.now());
          setTimeout(function () {
            streamBot(m.text, function () {
              if (!S.open) notifyReply(m);
              if (pendingCount()) setTimeout(function () { if (pendingCount()) showTyping(true); }, 700);
              setTimeout(done, 800);
            });
          }, wait);
        });
      });
    });
  }
  /* Petite notification en bas à gauche quand une réponse arrive et que le chat n'est pas ouvert. */
  function notifyReply(m) {
    if (!fab || S.open) return;
    var preview = String(m.text || '').replace(/\*\*/g, '').replace(/\s+/g, ' ').trim();
    if (preview.length > 110) preview = preview.slice(0, 107).replace(/\s+\S*$/, '') + '…';
    teaser.querySelector('p').textContent = preview;
    teaser.classList.add('grc-show'); pulseEl.style.display = 'block'; fab.grcBubble.classList.add('grc-has-unread');
  }

  /* ───────── rendu léger du markdown de l'IA (gras, listes, liens) ───────── */
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function inline(s) {
    return s
      .replace(/(https?:\/\/[^\s<]+?)([.,;:!?)]*)(?=\s|$)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>$2')
      .replace(/\*\*([^*\n]+)\*\*/g, '<b>$1</b>')
      .replace(/(^|[\s(])\*([^*\n]+)\*(?=[\s.,;:!?)]|$)/g, '$1<i>$2</i>');
  }
  function md(text) {
    var lines = esc(text).replace(/\r/g, '').split('\n'), out = [], para = [], list = null;
    var flushP = function () { if (para.length) { out.push('<p>' + para.map(inline).join('<br>') + '</p>'); para = []; } };
    var flushL = function () { if (list) { out.push('<ul>' + list.map(function (x) { return '<li>' + inline(x) + '</li>'; }).join('') + '</ul>'); list = null; } };
    lines.forEach(function (ln) {
      var m = ln.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
      if (m) { flushP(); (list = list || []).push(m[1]); return; }
      flushL();
      if (!ln.trim()) { flushP(); return; }
      para.push(ln);
    });
    flushP(); flushL();
    return out.join('');
  }

  /* ───────── DOM ───────── */
  var root, fab, teaser, panel, msgsEl, typingEl, chipsEl, inputEl, sendBtn, pulseEl, unreadEl;
  function el(tag, cls, html) { var d = document.createElement(tag); if (cls) d.className = cls; if (html != null) d.innerHTML = html; return d; }
  function avatars(cls) { return '<span class="grc-avs">' + AVATARS.map(function (u) { return '<img class="grc-av' + (cls ? ' ' + cls : '') + '" src="' + u + '" alt="" width="30" height="30">'; }).join('') + '</span>'; }
  function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }

  var CSS = '\
.grc-root,.grc-root *{box-sizing:border-box;margin:0;padding:0}.grc-root *{line-height:inherit}\
.grc-root{-webkit-text-size-adjust:100%;--grc-brand:#FA7E34;--grc-brand-dark:#e2661f;--grc-brand-text:#fff;--grc-green:#12b76a;--grc-line:#e5e5e5;--grc-bot:#f1f1f1;--grc-ink:#1a1a1a;--grc-pulse:rgba(250,126,52,.45);font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:var(--grc-ink);font-size:14px;line-height:1.4;-webkit-font-smoothing:antialiased}\
.grc-root[data-scheme="bleu"]{--grc-brand:#334fb4;--grc-brand-dark:#2a3f8f;--grc-pulse:rgba(51,79,180,.45)}\
.grc-root[data-scheme="nuit"]{--grc-brand:#1a1a1a;--grc-brand-dark:#000;--grc-pulse:rgba(0,0,0,.35)}\
.grc-root .grc-fab{position:fixed;left:22px;bottom:22px;z-index:var(--grc-z);display:flex;flex-direction:column;align-items:flex-start}\
.grc-root[data-lift="1"] .grc-fab{bottom:96px}\
.grc-root .grc-bubble{position:relative;width:58px;height:58px;border-radius:50%;background:var(--grc-brand);border:0;cursor:pointer;box-shadow:0 6px 24px rgba(0,0,0,.22);display:flex;align-items:center;justify-content:center;transition:transform .15s;transform:translateZ(0);will-change:transform;padding:0}\
.grc-root .grc-bubble:hover{transform:scale(1.06) translateZ(0)}\
.grc-root .grc-bubble svg{width:27px;height:27px;fill:var(--grc-brand-text);display:block}\
.grc-root .grc-bubble .grc-dot{position:absolute;top:2px;right:2px;width:13px;height:13px;background:var(--grc-green);border:2.5px solid #fff;border-radius:50%}\
.grc-root .grc-bubble .grc-unread{position:absolute;top:-4px;right:-4px;min-width:20px;height:20px;background:#e02424;color:#fff;font-size:11.5px;font-weight:600;border-radius:10px;display:none;align-items:center;justify-content:center;padding:0 5px}\
.grc-root .grc-bubble.grc-has-unread .grc-unread{display:flex}\
.grc-root .grc-pulse{position:absolute;inset:0;border-radius:50%;box-shadow:0 0 0 0 var(--grc-pulse);animation:grc-pulse 2.2s infinite;display:none}\
@keyframes grc-pulse{70%{box-shadow:0 0 0 16px rgba(0,0,0,0)}100%{box-shadow:0 0 0 0 rgba(0,0,0,0)}}\
.grc-root .grc-teaser{position:absolute;left:0;bottom:72px;width:320px;max-width:calc(100vw - 44px);background:#fff;border-radius:16px;box-shadow:0 10px 36px rgba(0,0,0,.18);padding:14px 16px;opacity:0;transform:translateY(8px);pointer-events:none;transition:.28s;cursor:pointer}\
.grc-root .grc-teaser.grc-show{opacity:1;transform:none;pointer-events:auto}\
.grc-root .grc-teaser .grc-who{display:flex;align-items:center;gap:10px;margin-bottom:10px;line-height:1.3}\
.grc-root .grc-teaser .grc-name{font-size:14px;font-weight:600;line-height:1.3}\
.grc-root .grc-teaser .grc-status{font-size:12px;line-height:1.3;margin-top:2px;color:var(--grc-green);display:flex;align-items:center;gap:4px}\
.grc-root .grc-teaser .grc-status::before{content:"";width:7px;height:7px;border-radius:50%;background:var(--grc-green)}\
.grc-root .grc-teaser p{font-size:14.5px;line-height:1.45;color:#333;margin:0}\
.grc-root .grc-teaser .grc-tclose{position:absolute;top:-9px;right:-9px;width:24px;height:24px;border-radius:50%;background:#fff;border:1px solid var(--grc-line);color:#777;font-size:13px;cursor:pointer;line-height:1;box-shadow:0 2px 8px rgba(0,0,0,.12);font-family:inherit}\
.grc-root .grc-avs{display:inline-flex}\
.grc-root .grc-av{width:30px;height:30px;border-radius:50%;border:2px solid #fff;object-fit:cover;background:#ddd;display:block}\
.grc-root .grc-avs .grc-av+.grc-av{margin-left:-9px}\
.grc-root .grc-panel{position:fixed;left:22px;bottom:92px;width:378px;max-width:calc(100vw - 44px);height:min(600px,calc(100vh - 130px));background:#fff;border-radius:18px;box-shadow:0 18px 60px rgba(0,0,0,.26);display:flex;flex-direction:column;overflow:hidden;overscroll-behavior:contain;opacity:0;transform:translateY(14px) scale(.98);pointer-events:none;transition:.25s;z-index:var(--grc-z-panel)}\
.grc-root .grc-panel.grc-open{opacity:1;transform:none;pointer-events:auto}\
.grc-root .grc-panel.grc-locked{transition:none}\
.grc-root .grc-panel.grc-locked .grc-head{position:fixed;top:0;left:0;right:0;z-index:2}\
.grc-root[data-lift="1"] .grc-panel{bottom:166px}\
.grc-root .grc-panel.grc-inline{position:static;width:100%;max-width:none;height:540px;opacity:1;transform:none;pointer-events:auto;box-shadow:0 10px 36px rgba(0,0,0,.10);border:1px solid var(--grc-line)}\
.grc-root .grc-panel.grc-inline .grc-x{display:none}\
@media (max-width:767px){.grc-root .grc-msg{font-size:15px}.grc-root .grc-chip{font-size:14px;padding:9px 14px}.grc-root .grc-head .grc-n{font-size:16px}.grc-root .grc-head .grc-s{font-size:12.5px}.grc-root .grc-teaser p{font-size:15px}.grc-root .grc-teaser .grc-name{font-size:14px}.grc-root .grc-teaser .grc-status{font-size:12px}.grc-root .grc-status{font-size:11px}.grc-root .grc-panel:not(.grc-inline){left:0;right:0;top:0;bottom:0 !important;width:auto;max-width:none;height:auto;border-radius:0}.grc-root .grc-panel:not(.grc-inline) .grc-head{padding-top:calc(16px + env(safe-area-inset-top))}.grc-root .grc-panel.grc-inline{height:470px}.grc-root .grc-input{padding-bottom:calc(14px + env(safe-area-inset-bottom))}}\
.grc-root .grc-head{background:var(--grc-brand);color:var(--grc-brand-text);padding:16px 18px 14px;display:flex;align-items:center;gap:12px;flex-shrink:0}\
.grc-root .grc-head .grc-av{border-color:var(--grc-brand)}\
.grc-root .grc-head .grc-n{font-weight:600;font-size:16px;line-height:1.3}\
.grc-root .grc-head .grc-s{font-size:12.5px;line-height:1.3;margin-top:2px;opacity:.92;display:flex;align-items:flex-start;gap:5px}\
.grc-root .grc-head .grc-s::before{content:"";width:8px;height:8px;flex-shrink:0;margin-top:4px;border-radius:50%;background:var(--grc-green);box-shadow:0 0 0 2px rgba(255,255,255,.35)}\
.grc-root .grc-x{margin-left:auto;background:rgba(255,255,255,.16);border:0;color:var(--grc-brand-text);width:30px;height:30px;border-radius:8px;font-size:15px;cursor:pointer;font-family:inherit;flex-shrink:0}\
.grc-root .grc-msgs{flex:1;overflow-y:auto;scroll-behavior:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;padding:18px 16px 10px;display:flex;flex-direction:column;gap:10px;background:#fafafa;scrollbar-width:thin}\
.grc-root .grc-msg{max-width:82%;padding:10px 14px;border-radius:14px;font-size:14px;line-height:1.5;word-wrap:break-word;overflow-wrap:anywhere}\
.grc-root .grc-msg p,.grc-root .grc-msg ul,.grc-root .grc-msg li,.grc-root .grc-msg b,.grc-root .grc-msg i,.grc-root .grc-msg a{font-size:inherit;line-height:inherit;font-family:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0;text-transform:none}\
.grc-root .grc-msg b{font-weight:600}.grc-root .grc-msg ul{list-style:disc}\
.grc-root .grc-msg p+p,.grc-root .grc-msg p+ul,.grc-root .grc-msg ul+p{margin-top:8px}\
.grc-root .grc-msg ul{padding-left:18px}\
.grc-root .grc-msg a{color:inherit;text-decoration:underline}\
.grc-root .grc-msg.grc-bot{background:var(--grc-bot);color:#222;border-bottom-left-radius:5px;align-self:flex-start;white-space:pre-line}\
.grc-root .grc-msg.grc-bot.grc-html{white-space:normal}\
.grc-root .grc-msg.grc-user{background:var(--grc-brand);color:var(--grc-brand-text);border-bottom-right-radius:5px;align-self:flex-end;white-space:pre-line}\
.grc-root[data-scheme="nuit"] .grc-msg.grc-user{background:#333}\
.grc-root .grc-msg.grc-err{background:#fff4ee;color:#7a3c12;border:1px solid #f6d3bd;align-self:flex-start;border-bottom-left-radius:5px}\
.grc-root .grc-msg.grc-err button{display:block;margin-top:8px;border:1.5px solid var(--grc-brand);color:var(--grc-brand);background:#fff;border-radius:18px;font-family:inherit;font-size:12.3px;padding:6px 12px;cursor:pointer}\
.grc-root .grc-status{align-self:flex-end;font-size:10.5px;color:#9a9a9a;margin:-4px 4px 0 0}\
.grc-root .grc-typing{align-self:flex-start;background:var(--grc-bot);border-radius:14px;border-bottom-left-radius:5px;padding:12px 16px;display:none}\
.grc-root .grc-typing.grc-show{display:block}\
.grc-root .grc-typing i{display:inline-block;width:7px;height:7px;background:#9a9a9a;border-radius:50%;margin:0 2px;animation:grc-tp 1.1s infinite}\
.grc-root .grc-typing i:nth-child(2){animation-delay:.18s}.grc-root .grc-typing i:nth-child(3){animation-delay:.36s}\
@keyframes grc-tp{35%{transform:translateY(-5px);opacity:.5}}\
.grc-root .grc-chips{display:flex;flex-wrap:wrap;gap:8px;padding:4px 16px 10px;background:#fafafa;flex-shrink:0}\
.grc-root .grc-chips:empty{display:none}\
.grc-root .grc-chip,.grc-root .grc-x,.grc-root .grc-tclose,.grc-root .grc-send,.grc-root .grc-bubble,.grc-root .grc-input input{letter-spacing:normal;text-transform:none;min-height:0;min-width:0;line-height:1.3;-webkit-appearance:none;appearance:none;text-shadow:none}\
.grc-root .grc-chip,.grc-root .grc-x,.grc-root .grc-tclose,.grc-root .grc-send,.grc-root .grc-input input{box-shadow:none}\
.grc-root .grc-chip{border:1.5px solid var(--grc-brand);color:var(--grc-brand);background:#fff;border-radius:18px;font-family:inherit;font-size:13px;padding:7px 13px;cursor:pointer;transition:.15s;text-align:left}\
.grc-root .grc-chip:hover{background:var(--grc-brand);color:var(--grc-brand-text)}\
.grc-root[data-scheme="nuit"] .grc-chip{border-color:#333;color:#222}\
.grc-root[data-scheme="nuit"] .grc-chip:hover{background:#1a1a1a;color:#fff}\
.grc-root .grc-input{display:flex;gap:10px;padding:12px 14px 14px;border-top:1px solid var(--grc-line);background:#fff;flex-shrink:0}\
.grc-root .grc-input input{flex:1;border:0;outline:0;font-family:inherit;font-size:16px;color:#222;background:transparent;min-width:0}\
@media (min-width:768px){.grc-root .grc-input input{font-size:14px}}\
.grc-root .grc-input input::placeholder{color:#aaa}\
.grc-root .grc-send{width:38px;height:38px;border-radius:10px;border:0;background:var(--grc-brand);cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0}\
.grc-root .grc-send[disabled]{opacity:.45;cursor:default}\
.grc-root .grc-send svg{width:17px;height:17px;fill:var(--grc-brand-text);display:block}\
';

  function build() {
    var style = el('style'); style.textContent = CSS; document.head.appendChild(style);
    root = el('div', 'grc-root'); root.dataset.scheme = CFG.scheme; root.style.setProperty('--grc-z', CFG.zIndex); root.style.setProperty('--grc-z-panel', CFG.zIndexPanel);
    var lift = CFG.lift == null ? (S.page === 'achat' || !!document.querySelector('.mm-bloc-product-sticky')) : !!CFG.lift;
    root.dataset.lift = lift ? '1' : '0';
    var U = T().ui;

    panel = el('div', 'grc-panel');
    panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', U.name);
    panel.innerHTML =
      '<div class="grc-head">' + avatars() + '<div><div class="grc-n">' + esc(U.name) + '</div><div class="grc-s">' + esc(U.status) + '</div></div>' +
      '<button class="grc-x" type="button" aria-label="' + esc(U.close) + '">✕</button></div>' +
      '<div class="grc-msgs"></div>' +
      '<div class="grc-chips"></div>' +
      '<div class="grc-input"><input type="text" maxlength="2000" autocomplete="off" placeholder="' + esc(U.placeholder) + '" aria-label="' + esc(U.placeholder) + '">' +
      '<button class="grc-send" type="button" aria-label="' + esc(U.send) + '"><svg viewBox="0 0 24 24"><path d="M3 20l18-8L3 4v6l12 2-12 2z"/></svg></button></div>';
    msgsEl = panel.querySelector('.grc-msgs'); chipsEl = panel.querySelector('.grc-chips');
    inputEl = panel.querySelector('input'); sendBtn = panel.querySelector('.grc-send');
    typingEl = el('div', 'grc-typing', '<i></i><i></i><i></i>'); msgsEl.appendChild(typingEl);

    var host = document.getElementById('georide-chat');
    S.inline = !!host;
    if (S.inline) {
      panel.classList.add('grc-inline');
      root.appendChild(panel);
      host.appendChild(root);
    } else {
      fab = el('div', 'grc-fab');
      teaser = el('div', 'grc-teaser');
      teaser.innerHTML = '<button class="grc-tclose" type="button" aria-label="' + esc(U.close) + '">✕</button>' +
        '<div class="grc-who">' + avatars() + '<div><div class="grc-name">' + esc(U.name) + '</div><div class="grc-status">' + esc(U.status) + '</div></div></div>' +
        '<p>' + esc(T().teasers[S.page] || '') + '</p>';
      var bubble = el('button', 'grc-bubble');
      bubble.type = 'button'; bubble.setAttribute('aria-label', U.open);
      bubble.innerHTML = '<span class="grc-pulse"></span><svg viewBox="0 0 24 24"><path d="M12 3C6.9 3 3 6.5 3 10.8c0 2.4 1.2 4.5 3.2 5.9-.1.8-.5 2-1.6 3.1-.2.2 0 .6.3.5 1.9-.3 3.4-1.1 4.3-1.7.9.2 1.8.3 2.8.3 5.1 0 9-3.5 9-7.8S17.1 3 12 3z"/></svg><span class="grc-dot"></span><span class="grc-unread">1</span>';
      pulseEl = bubble.querySelector('.grc-pulse'); unreadEl = bubble.querySelector('.grc-unread');
      fab.appendChild(teaser); fab.appendChild(bubble);
      root.appendChild(fab); root.appendChild(panel);
      document.body.appendChild(root);
      bubble.addEventListener('click', function () { S.open ? closeChat() : openChat(); });
      bubble.grc = true; fab.grcBubble = bubble;
      teaser.addEventListener('click', function (e) { if (e.target.classList.contains('grc-tclose')) { e.stopPropagation(); hideTeaser(true); } else openChat(); });
      panel.querySelector('.grc-x').addEventListener('click', closeChat);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && S.open) closeChat(); });
      armTeaser();
    }
    sendBtn.addEventListener('click', submit);
    inputEl.addEventListener('focus', function () { lock.hFocus = window.innerHeight; reserveKeyboard(); if (lock.on) { setTimeout(fitViewport, 100); setTimeout(fitViewport, 400); setTimeout(fitViewport, 800); } });
    inputEl.addEventListener('blur', function () { if (lock.on) { setTimeout(fitViewport, 100); setTimeout(fitViewport, 400); } });
    inputEl.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); submit(); } });
    if (S.inline) openChat();
    var hashOpen = function () { if (location.hash === '#chat') openChat(); };
    hashOpen(); window.addEventListener('hashchange', hashOpen);
    resumePending();
    document.addEventListener('visibilitychange', function () { if (!document.hidden && pendingCount() && !polling) startPolling(); });
  }

  /* ───────── relance proactive ───────── */
  function teaserSeenRecently() {
    try {
      var at = parseInt(localStorage.getItem(CFG.teaserKey) || '0', 10);
      return at && (Date.now() - at) < CFG.teaserCooldownMin * 60000;
    } catch (e) { return false; }
  }
  function armTeaser() {
    if (!(S.page === 'produit' || S.page === 'achat' || S.page === 'accueil')) return;
    var test = location.hash === '#chat-test';
    if (test) { try { localStorage.removeItem(CFG.teaserKey); } catch (e) {} }
    if (teaserSeenRecently()) return;
    var fired = false;
    var fire = function () { if (fired) return; fired = true; window.removeEventListener('scroll', onScroll); showTeaser(); };
    var onScroll = function () {
      if (window.scrollY >= (isMobile() ? CFG.teaserScrollPxMobile : CFG.teaserScrollPx)) fire();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    setTimeout(fire, test ? 1500 : CFG.teaserDelay);
  }
  function showTeaser() {
    if (S.open || S.started || S.teaserShown) return;
    S.teaserShown = true;
    try { localStorage.setItem(CFG.teaserKey, String(Date.now())); } catch (e) {}
    teaser.classList.add('grc-show'); pulseEl.style.display = 'block'; fab.grcBubble.classList.add('grc-has-unread');
  }
  function hideTeaser() {
    if (!teaser) return;
    teaser.classList.remove('grc-show'); pulseEl.style.display = 'none'; fab.grcBubble.classList.remove('grc-has-unread');
  }

  /* ───────── ouverture / fermeture ───────── */
  /* Sur mobile plein écran, la page derrière est gelée (sinon iOS fait défiler le site au lieu du fil)
     et le panneau suit la zone visible quand le clavier s'ouvre (visualViewport). */
  var lock = { on: false, y: 0 };
  /* Clavier iPhone (v0.19) : la page derrière est gelée (position: fixed) pour que le fil soit seul à défiler,
     et la hauteur du clavier est réservée en bas du panneau à l'instant du focus, avant que Safari ne décide
     de faire défiler pour montrer le champ : le champ étant déjà visible, rien ne bouge, l'en-tête reste.
     La hauteur réelle du clavier est mesurée à la première ouverture et mémorisée. */
  /* Hauteur à réserver pour le clavier. Sur les iPhone récents, Safari réduit lui-même la fenêtre quand le
     clavier s'ouvre : il n'y a rien à réserver (valeur mémorisée 0). Sur les autres, la partie couverte est
     mesurée à la première ouverture et mémorisée. Avant toute mesure, 45 % de l'écran. */
  function kbGuess() {
    try { var v = localStorage.getItem(CFG.kbKey); if (v !== null && v !== '') return Math.max(0, parseInt(v, 10) || 0); } catch (e) {}
    return Math.round(window.innerHeight * 0.45);
  }
  function lockBody() {
    if (lock.on || S.inline || !isMobile()) return;
    lock.on = true; lock.y = window.scrollY || 0; lock.h0 = window.innerHeight;
    var b = document.body.style;
    lock.saved = { position: b.position, top: b.top, left: b.left, right: b.right, width: b.width, overflow: b.overflow, html: document.documentElement.style.overflow };
    b.position = 'fixed'; b.top = (-lock.y) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%'; b.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    panel.classList.add('grc-locked');
    pinHeader();
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', fitViewport); window.visualViewport.addEventListener('scroll', fitViewport); }
    window.addEventListener('resize', fitViewport);
  }
  /* En-tête « L'équipe GeoRide » fixé en haut de l'écran sur mobile : hors du flux du panneau, sa hauteur est
     réservée en haut, et il suit la zone visible si Safari la décale. */
  function pinHeader() {
    var head = panel.querySelector('.grc-head');
    if (!head) return;
    panel.style.paddingTop = head.offsetHeight + 'px';
  }
  function unpinHeader() { panel.style.paddingTop = ''; }
  function unlockBody() {
    if (!lock.on) return;
    lock.on = false;
    var b = document.body.style, sv = lock.saved || {};
    b.position = sv.position || ''; b.top = sv.top || ''; b.left = sv.left || ''; b.right = sv.right || ''; b.width = sv.width || ''; b.overflow = sv.overflow || '';
    document.documentElement.style.overflow = sv.html || '';
    panel.classList.remove('grc-locked');
    panel.style.paddingBottom = '';
    unpinHeader();
    if (window.visualViewport) { window.visualViewport.removeEventListener('resize', fitViewport); window.visualViewport.removeEventListener('scroll', fitViewport); }
    window.removeEventListener('resize', fitViewport);
    window.scrollTo(0, lock.y);
  }
  function reserveKeyboard() {
    if (!lock.on) return;
    panel.style.paddingBottom = kbGuess() + 'px';
    scrollDown();
  }
  var fitPending = false;
  function fitViewport() {
    if (!lock.on || fitPending) return;
    fitPending = true;
    requestAnimationFrame(function () {
      fitPending = false;
      if (!lock.on) return;
      var vv = window.visualViewport;
      if (!vv) return;
      /* Mesure sur ton iPhone (v0.22) : à l'ouverture du clavier, Safari réduit la fenêtre (768 → 431) ET décale la
         zone visible de la hauteur du clavier si le champ n'est pas déjà visible ; c'est ce décalage qui fait
         disparaître puis « remonter » le bandeau. Donc : (1) au focus, réserver en bas la hauteur mémorisée du
         clavier pour que le champ soit déjà à sa place, aucun décalage ; (2) clavier ouvert, corriger la réserve
         d'après la géométrie réelle (bas du champ = bas de la zone visible), et mémoriser cette valeur. */
      var focused = document.activeElement === inputEl;
      var ref = lock.hFocus || lock.h0;
      var keyboardUp = focused && vv.height < ref - 100;
      if (!focused) {
        panel.style.paddingBottom = '0px';
      } else if (keyboardUp) {
        var cur = parseInt(panel.style.paddingBottom || '0', 10) || 0;
        var delta = Math.round(inputEl.getBoundingClientRect().bottom - (vv.offsetTop + vv.height));
        if (Math.abs(delta) > 2) { cur = Math.max(0, cur + delta); panel.style.paddingBottom = cur + 'px'; }
        try { localStorage.setItem(CFG.kbKey, String(cur)); } catch (e) {}
      } else {
        panel.style.paddingBottom = kbGuess() + 'px';
      }
      var head = panel.querySelector('.grc-head');
      if (head) panel.style.paddingTop = head.offsetHeight + 'px';
      scrollDown();
      setTimeout(scrollDown, 150); setTimeout(scrollDown, 450);
    });
  }
  function openChat() {
    hideTeaser();
    panel.classList.add('grc-open'); S.open = true;
    lockBody();
    if (!S.started) { S.started = true; start(); }
    if (!isMobile() || S.inline) inputEl.focus();
  }
  function closeChat() { panel.classList.remove('grc-open'); S.open = false; inputEl.blur(); unlockBody(); }

  /* Reprise : si un couple id/token est stocké, on recharge l'historique ; sinon accueil local. */
  function start() {
    var pair = loadPair();
    if (!pair) return welcome();
    S.pair = pair;
    api('GET', '/v1/support/web/conversations/' + encodeURIComponent(pair.id), null, pair.token).then(function (r) {
      if (r.status === 404) {
        if (r.body && r.body.code === 'SUPPORT_WEB_CHAT_DISABLED') return destroy();
        dropPair(); return welcome();
      }
      if (r.status !== 200) return welcome();
      return listMessages(pair).then(function (msgs) {
        msgs.forEach(function (m) { S.known[m.id] = 1; });
        if (!msgs.length) return welcome();
        msgs.forEach(function (m) { addMsg(m.role === 'user' ? 'grc-user' : 'grc-bot', m.text, m.role !== 'user'); });
        S.historyLoaded = true;
        if (pendingCount()) { addStatus(T().ui.seen); setTimeout(function () { if (pendingCount()) showTyping(true); }, 400); }
        scrollDown();
      }, function () { welcome(); });
    }, function () { welcome(); });
  }
  function welcome() {
    S.historyLoaded = true;
    addMsg('grc-bot', txt('welcome'), false);
    showChips(txt('chips'));
  }

  /* ───────── fil de messages ───────── */
  function addMsg(cls, text, asHtml) {
    var d = el('div', 'grc-msg ' + cls);
    if (asHtml) { d.classList.add('grc-html'); d.innerHTML = md(text); } else d.textContent = text;
    msgsEl.insertBefore(d, typingEl); scrollDown(); return d;
  }
  function addStatus(label) { var s = el('div', 'grc-status'); s.textContent = label; msgsEl.insertBefore(s, typingEl); scrollDown(); return s; }
  function addError(message, retryText) {
    var d = el('div', 'grc-msg grc-err'); d.textContent = message;
    if (retryText != null) {
      var b = el('button', null, esc(T().ui.retry)); b.type = 'button';
      b.addEventListener('click', function () { d.remove(); send(retryText); });
      d.appendChild(b);
    }
    msgsEl.insertBefore(d, typingEl); scrollDown(); return d;
  }
  function showChips(list) {
    chipsEl.innerHTML = '';
    (list || []).forEach(function (t) { var b = el('button', 'grc-chip'); b.type = 'button'; b.textContent = t; b.addEventListener('click', function () { send(t); }); chipsEl.appendChild(b); });
  }
  function scrollDown() { msgsEl.scrollTop = msgsEl.scrollHeight; }
  function showTyping(on) { typingEl.classList.toggle('grc-show', !!on); if (on) scrollDown(); }

  /* La réponse s'affiche d'un coup, jamais mot à mot (demande Thomas 04/09 : pas d'animation de chatbot).
     Option splitGreeting : si la réponse commence par une ligne de salutation (« Bonjour, »), elle part
     seule dans une première bulle, puis le reste arrive quelques secondes après, comme un humain qui écrit. */
  function greetingSplit(text) {
    var m = String(text).match(/^\s*([^\n]{1,30})\n+([\s\S]+)$/);
    if (!m) return null;
    var first = m[1].trim();
    if (!/^(bonjour|bonsoir|salut|hello|hi|hey|good (morning|afternoon|evening)|hallo|guten (tag|morgen|abend)|hola|buenos días|buenas tardes|ciao|buongiorno|buonasera|salve|goedemorgen|goedemiddag|olá|bom dia|boa tarde|cześć|dzień dobry|witaj)\b/i.test(first) || first.split(/\s+/).length > 3) return null;
    return { greeting: first, rest: m[2].trim() };
  }
  function streamBot(text, done) {
    showTyping(false);
    msgsEl.querySelectorAll('.grc-status').forEach(function (e) { e.remove(); });
    var parts = CFG.splitGreeting ? greetingSplit(text) : null;
    if (!parts) { addMsg('grc-bot', text, true); done && done(); return; }
    addMsg('grc-bot', parts.greeting, true);
    setTimeout(function () { showTyping(true); }, 600);
    setTimeout(function () { showTyping(false); addMsg('grc-bot', parts.rest, true); done && done(); }, 2200 + Math.random() * 1500);
  }

  /* Chorégraphie « vrai chat » : Envoyé → Vu → écrit… → réponse. L'appel API part dès l'envoi ;
     la réponse est retenue jusqu'à la fin des étapes si elle est prête plus tôt, jamais retardée sinon. */
  function choreo(statusEl) {
    var timers = [], accepted = false, readyAtMs = 0;
    var t0 = Date.now();
    var tVu = 2200 + Math.random() * 1400;
    var tLoader = tVu + (tVu - 1400) + 800 + Math.random() * 1600;
    var tReponse = tLoader + 1700 + Math.random() * 900;
    /* Rien ne s'affiche tant que l'API n'a pas accepté le message (202) : si elle est en panne, on ne montre
       ni « Vu » ni « écrit… », seulement l'erreur. Les étapes gardent leur tempo si l'accord arrive vite,
       et s'enchaînent avec un écart minimal s'il arrive tard. */
    function schedule() {
      var el = Date.now() - t0;
      var vuAt = Math.max(0, tVu - el);
      var loaderAt = Math.max(vuAt + 600, tLoader - el);
      var readyAt = Math.max(loaderAt + 1200, tReponse - el);
      readyAtMs = Date.now() + readyAt;
      timers.push(setTimeout(function () { statusEl.textContent = T().ui.seen; }, vuAt));
      timers.push(setTimeout(function () { if (pendingCount()) showTyping(true); }, loaderAt));
    }
    return {
      accept: function () { if (!accepted) { accepted = true; schedule(); } return readyAtMs; },
      cancel: function () { timers.forEach(clearTimeout); }
    };
  }

  function submit() {
    var v = inputEl.value.trim();
    if (!v) return;
    inputEl.value = '';
    send(v);
  }
  function send(text) {
    if (S.destroyed) return;
    showChips([]);
    addMsg('grc-user', text, false);
    var st = addStatus(T().ui.sent);
    var c = choreo(st);
    var hadPair = !!S.pair;
    lastText = text;
    postMessage(text)
      .then(function (sent) {
        revealNotBefore = Math.max(revealNotBefore, c.accept());
        if (hadPair && !S.pair) { pending = {}; addError(T().ui.errFull); }
        var id = (sent && sent.id) || ('local-' + Date.now());
        pending[id] = { text: text, at: Date.now() };
        if (sent && sent.id) S.known[sent.id] = 1;
        lastActivity = Date.now();
        savePending();
        startPolling();
      })
      .catch(function (e) {
        c.cancel(); st.remove();
        if (!pendingCount()) showTyping(false);
        var U = T().ui;
        if (e && e.code === 'SUPPORT_WEB_CHAT_DISABLED') return destroy();
        if (e && e.kind === 'network') return addError(U.errNet, text);
        if (e && e.status === 429) return addError(U.errBusy, text);
        if (e && e.status === 422) return addError(U.errTimeout, null);
        addError(U.errDown, text);
        if (CFG.debug && window.console) console.warn('[georide-chat]', e);
      });
  }

  function destroy() {
    S.destroyed = true; unlockBody();
    if (root && root.parentNode) root.parentNode.removeChild(root);
  }

  /* ───────── API publique (tests, page contact, débogage) ───────── */
  window.GeoRideChat = {
    version: '0.24',
    open: function () { openChat(); },
    close: function () { closeChat(); },
    reset: function () { dropPair(); try { localStorage.removeItem(CFG.teaserKey); } catch (e) {} },
    seed: function (id, token) { savePair({ id: id, token: token }); },
    pair: function () { return loadPair(); },
    avatars: function () { return AVATARS.slice(); },
    lang: function () { return S.lang; },
    languages: function () { return Object.keys(L); },
    page: function () { return S.page; }
  };

  function init() {
    S.lang = detectLang(); S.page = detectPage(); AVATARS = pickAvatars();
    S.pair = loadPair();
    if (document.body) build(); else document.addEventListener('DOMContentLoaded', build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
